/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.shared = {

  refresh(element, html) {
    const $container       = $(element);
    const $new_html        = $(html);
    return $container.replaceWith($new_html);
  },


  update_group_name(group_name, ungrouped) {
    if (!ungrouped) {
      return $(".js-nav-header-subtitle").text(group_name);
    }
  }
};
